import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHeader, Loading } from "../components/Layout";
import { SpeciesToggle } from "../components/SearchForm";
import { api } from "../lib/api";

export default function Treatments() {
  const [species, setSpecies] = useState("dog");
  const [items, setItems] = useState(null);
  const [cats, setCats] = useState([]);
  useEffect(() => {
    api.get("/public/categories").then((r) => setCats(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    api.get("/public/services", { params: { species } }).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [species]);
  return (
    <div data-testid="treatments-page">
      <PageHeader eyebrow="Behandlingskatalog" title="Behandlinger for hund og kat">Se, hvad de mest almindelige behandlinger indeholder, og sammenlign priser hos klinikker.</PageHeader>
      <div className="container-vp py-10">
        <SpeciesToggle value={species} onChange={setSpecies} />
        {!items ? <Loading /> : cats.map((c) => {
          const list = items.filter((s) => s.category_id === c.id);
          if (!list.length) return null;
          return (
            <section key={c.id} className="mt-10" data-testid={`category-${c.code}`}>
              <h2 className="text-xl font-bold text-[#153C3A]">{c.name_da}</h2>
              <p className="text-sm text-[#52706D] mt-1">{c.description_da}</p>
              <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 mt-4">
                {list.map((s) => (
                  <Link key={s.id} to={`/behandlinger/${s.slug}`} className="group card-vp p-5 hover:shadow-md transition-shadow" data-testid={`treatment-card-${s.slug}`}>
                    <h3 className="font-heading font-bold text-[#153C3A]">{s.name_da}</h3>
                    <p className="text-sm text-[#52706D] mt-1 line-clamp-2">{s.description_da}</p>
                    {s.variants?.length > 0 && <p className="text-xs text-[#087F72] mt-2">Priser efter vægtklasse</p>}
                    <span className="inline-flex items-center gap-1 text-sm font-semibold text-[#087F72] mt-3">Læs mere <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" /></span>
                  </Link>
                ))}
              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
}
